const ArgumentType = require("../../extension-support/argument-type");
const Cast = require("../../util/cast");
const BlockType = require("../../extension-support/block-type");
const formatMessage = require("format-message");
const log = require("../../util/log");
const JoyConLeft = require("./joycon").JoyConLeft;
const JoyConRight = require("./joycon").JoyConRight;

// eslint-disable-next-line max-len
// const iconURI = 

// eslint-disable-next-line max-len
const menuIconURI = "data:image/svg+xml;base64,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"

const AvailableLocales = ["en", "ja", "ja-Hira"];

const Message = {
    categoryName: {
        ja: "NS コントローラー",
        "ja-Hira": "NS コントローラー",
        en: "NS Joy-Con",
    },
    connectRight: {
        ja: "右のJoyConに接続する",
        "ja-Hira": "みぎのコントローラにつなぐ",
        en: "connect to right JoyCon",
    },
    connectLeft: {
        ja: "左のJoyConに接続する",
        "ja-Hira": "ひだりのコントローラにつなぐ",
        en: "connect to left JoyCon",
    },
    getJoyStick: {
        ja: "[LR] スティックの [HV]",
        "ja-Hira": "[LR] スティックの [HV]",
        en: "[LR] stick [HV]",
    },
    getAcceleration: {
        ja: "[LR] 加速度 [XYZ]",
        "ja-Hira": "[LR] かそくど [XYZ]",
        en: "[LR] acceleration [XYZ]",
    },
    getOrientation: {
        ja: "[LR] 傾き [ORIENTATION]",
        "ja-Hira": "[LR] かたむき [ORIENTATION]",
        en: "[LR] orientation [ORIENTATION]",
    },
    getGyro: {
        ja: "[LR] 角速度 [XYZ]",
        "ja-Hira": "[LR] かくそくど [XYZ]",
        en: "[LR] angular velocity [XYZ]",
    },
    whenButtonPressedRight: {
        ja: "右コントローラの [BUTTON] を [PRESSED] とき",
        "ja-Hira": "みぎコントローラの [BUTTON] を [PRESSED] とき",
        en: "When right JoyCon's [BUTTON] [PRESSED]",
    },
    whenButtonPressedLeft: {
        ja: "左コントローラの [BUTTON] を [PRESSED] とき",
        "ja-Hira": "ひだりコントローラの [BUTTON] を [PRESSED] とき",
        en: "When left JoyCon's [BUTTON] [PRESSED]",
    },
    buttons: {
        up: { ja: "上", "ja-Hira": "うえ", en: "Up" },
        down: { ja: "下", "ja-Hira": "した", en: "Down" },
        left: { ja: "左", "ja-Hira": "ひだり", en: "Left" },
        right: { ja: "右", "ja-Hira": "みぎ", en: "Right" },
        capture: { ja: "キャプチャ", "ja-Hira": "キャプチャ", en: "Capture" },
        home: { ja: "ホーム", "ja-Hira": "ホーム", en: "Home" },
        l: { ja: "L", "ja-Hira": "L", en: "L" },
        minus: { ja: "マイナス", "ja-Hira": "マイナス", en: "Minus" },
        a: { ja: "A", "ja-Hira": "A", en: "A" },
        b: { ja: "B", "ja-Hira": "B", en: "B" },
        x: { ja: "X", "ja-Hira": "X", en: "X" },
        y: { ja: "Y", "ja-Hira": "Y", en: "Y" },
        r: { ja: "R", "ja-Hira": "R", en: "R" },
        plus: { ja: "プラス", "ja-Hira": "プラス", en: "Plus" },
    },
    menus: {
        Left: {
            ja: "左",
            "ja-Hira": "ひだり",
            en: "Left",
        },
        Right: {
            ja: "右",
            "ja-Hira": "ひだり",
            en: "Right",
        },
        Horizontal: {
            ja: "水平",
            "ja-Hira": "よこ",
            en: "Horizontal",
        },
        Vertical: {
            ja: "垂直",
            "ja-Hira": "たて",
            en: "Vertical",
        },
        X: {
            ja: "X",
            "ja-Hira": "X",
            en: "X",
        },
        Y: {
            ja: "Y",
            "ja-Hira": "Y",
            en: "Y",
        },
        Z: {
            ja: "Z",
            "ja-Hira": "Z",
            en: "Z",
        },
        Alpha: {
            ja: "alpha",
            "ja-Hira": "アルファ",
            en: "alpha",
        },
        Beta: {
            ja: "beta",
            "ja-Hira": "ベータ",
            en: "beta",
        },
        Gamma: {
            ja: "gamma",
            "ja-Hira": "ガンマ",
            en: "gamma",
        },
        Pressed: {
            ja: "押した",
            "ja-Hira": "おした",
            en: "pressed",
        },
        Released: {
            ja: "離した",
            "ja-Hira": "はなした",
            en: "released",
        },
    },
    connectionState: {
        none: {
            ja: "左のチェックボックスを押してね",
            "ja-Hira": "ひだりのしかくをおしてね",
            en: "please click the left checkbox",
        },
        not_found: {
            ja: "接続できませんでした",
            "ja-Hira": "つなげられませんでした",
            en: "could not connect",
        },
        try: {
            ja: "接続中...",
            "ja-Hira": "つないでいます...",
            en: "connecting...",
        },
        connected: {
            ja: "接続しました",
            "ja-Hira": "つなぎました",
            en: "connected",
        },
        disconnecting: {
            ja: "切断中",
            "ja-Hira": "きっています",
            en: "disconnecting...",
        },
        lost: {
            ja: "接続を失いました",
            "ja-Hira": "きえてしまいました",
            en: "lost connection",
        },
    },
    lost_alert: {
        ja:
            "接続を失いました。再接続するにはチェックボックスを一度外して、初めから接続をしてください。詳細はヘルプブロックを押して説明ページをご覧ください。",
        "ja-Hira":
            "つなぐことができませんでした。もういちどつなぎたいばあい、チェックボックスをはずして、はじめからやりなおしてください。くわしくはヘルプブロックをおしてかくにんしてください。",
        en:
            "disconnected. release the checkbox of connect block. then re-connect the device.",
    },
};

const ConnectionState = {
    NONE: "none",
    NOT_FOUND: "notfound",
    TRY: "connecting",
    CONNECTED: "connected",
    DISCONNECTING: "disconnecting",
    LOST: "lost",
};

class kurikitNSJoyConBlocks {
    constructor(runtime) {
        this.runtime = runtime;

        this._joyConRight = null;
        this._joyConLeft = null;
        this._joyConLeftValues = {
            isLeft: true,
            buttons: {},
        };
        this._joyConRightValues = {
            isLeft: false,
            buttons: {},
        };

        this._connections = {
            right: {
                clicked: false,
                state: ConnectionState.NONE,
                alert: false,
            },
            left: {
                clicked: false,
                state: ConnectionState.NONE,
                alert: false,
            },
        };

        this._intervalId = window.setInterval(
            this._updateConnectionState,
            200,
            this
        );
    }

    _updateConnectionState(that) {
        // player-only pages (play/player.html) have no Blockly workspace: the flyout
        // checkbox polled below only exists in the editor.
        const workspace = Blockly.getMainWorkspace();
        if (!workspace) return;

        var right = workspace.getBlockById(
            "nsjoycon_connectRight"
        );
        var left = workspace.getBlockById(
            "nsjoycon_connectLeft"
        );

        if (right)
            that._connections.right.clicked = right.flyoutCheckbox.clicked;
        if (left) that._connections.left.clicked = left.flyoutCheckbox.clicked;

        // LEFT
        if (that._connections.left.state === ConnectionState.NONE) {
            if (that._connections.left.clicked) {
                that._connections.left.state = ConnectionState.TRY;
                that.connectJoyConLeft();
            }
        }

        if (that._connections.left.state === ConnectionState.TRY) {
            if (that._joyConLeft !== null) {
                that._connections.left.state = ConnectionState.CONNECTED;
            }
        }

        // TRY の選択画面でキャンセルされた場合は、connect 関数に追加

        if (that._connections.left.state === ConnectionState.CONNECTED) {
            if (!that._connections.left.clicked) {
                that._connections.left.state = ConnectionState.DISCONNECTING;
            }
        }

        if (that._connections.left.state === ConnectionState.DISCONNECTING) {
            that.disconnectJoyConLeft();
            that._connections.left.state = ConnectionState.LOST;
        }

        if (that._connections.left.state === ConnectionState.NOT_FOUND) {
            if (!that._connections.left.alert) {
                alert(Message.lost_alert[that.setLocale()]);
                that._connections.left.alert = true;
            }

            if (!that._connections.left.clicked) {
                that._connections.left.state = ConnectionState.NONE;
            }
        }

        if (that._connections.left.state === ConnectionState.LOST) {
            if (that._joyConLeft === null) {
                that._connections.left.state = ConnectionState.NONE;
            }
        }

        // RIGHT
        if (that._connections.right.state === ConnectionState.NONE) {
            if (that._connections.right.clicked) {
                that._connections.right.state = ConnectionState.TRY;
                that.connectJoyConRight();
            }
        }

        if (that._connections.right.state === ConnectionState.TRY) {
            if (that._joyConRight !== null) {
                that._connections.right.state = ConnectionState.CONNECTED;
            }
        }

        // TRY の選択画面でキャンセルされた場合は、connect 関数に追加

        if (that._connections.right.state === ConnectionState.CONNECTED) {
            if (!that._connections.right.clicked) {
                that._connections.right.state = ConnectionState.DISCONNECTING;
            }
        }

        if (that._connections.right.state === ConnectionState.DISCONNECTING) {
            that.disconnectJoyConRight();
            that._connections.right.state = ConnectionState.LOST;
        }

        if (that._connections.right.state === ConnectionState.NOT_FOUND) {
            if (!that._connections.right.alert) {
                alert(Message.lost_alert[that.setLocale()]);
                that._connections.right.alert = true;
            }

            if (!that._connections.right.clicked) {
                that._connections.right.state = ConnectionState.NONE;
            }
        }

        if (that._connections.right.state === ConnectionState.LOST) {
            if (that._joyConRight === null) {
                that._connections.right.state = ConnectionState.NONE;
            }
        }
    }

    /**
     *
     * @param {*} productId 0x2007: Right, 0x2006: Left
     */
    _getJoyConFilter(productId) {
        return [
            {
                vendorId: 0x057e, // Nintendo Co., Ltd
                productId: productId,
            },
        ];
    }

    _wait(timeout) {
        return new Promise((resolve, reject) => setTimeout(resolve, timeout));
    }

    connectJoyConRight() {
        var that = this;
        const filters = this._getJoyConFilter(0x2007);

        if (this._joyConRight === null) {
            navigator.hid
                .requestDevice({ filters })
                .then((devices) => {
                    const device = devices[0];
                    return that.connectDevice(device);
                })
                .then((joycon) => {
                    that._joyConRight = joycon;
                    return Promise.resolve("connected");
                })
                .then(() => {
                    if (that._joyConRight !== null) {
                        that._joyConRight.addEventListener(
                            "hidinput",
                            (event) => {
                                that.catchJoyConEvent(
                                    that._joyConRightValues,
                                    event.detail
                                );
                            }
                        );
                    }
                })
                .catch((error) => {
                    log.log(`ERROR: ${error.message}`);
                    that._connections.right.state = ConnectionState.NOT_FOUND;
                    that._joyConRight = null;
                });
        }
    }

    disconnectJoyConRight() {
        var that = this;
        this._joyConRight.close().then(() => {
            that._joyConRight = null;
        });
    }

    connectJoyConLeft() {
        var that = this;
        const filters = this._getJoyConFilter(0x2006);

        if (this._joyConLeft === null) {
            navigator.hid
                .requestDevice({ filters })
                .then((devices) => {
                    const device = devices[0];
                    return that.connectDevice(device);
                })
                .then((joycon) => {
                    that._joyConLeft = joycon;
                    return Promise.resolve("connected");
                })
                .then(() => {
                    if (that._joyConLeft !== null) {
                        that._joyConLeft.addEventListener(
                            "hidinput",
                            (event) => {
                                that.catchJoyConEvent(
                                    that._joyConLeftValues,
                                    event.detail
                                );
                            }
                        );
                    }
                })
                .catch((error) => {
                    log.log(`ERROR: ${error.message}`);
                    that._connections.left.state = ConnectionState.NOT_FOUND;
                    that._joyConLeft = null;
                });
        }
    }

    disconnectJoyConLeft() {
        var that = this;
        this._joyConLeft.close().then(() => {
            that._joyConLeft = null;
        });
    }

    connectDevice(device) {
        var that = this;
        let joyCon;
        if (device.productId === 0x2006) {
            joyCon = new JoyConLeft(device);
        } else if (device.productId === 0x2007) {
            joyCon = new JoyConRight(device);
        }
        return Promise.resolve()
            .then(() => {
                return that._wait(100).then(() => {
                    return joyCon.open();
                });
            })
            .then(() => {
                return that._wait(100).then(() => {
                    return joyCon.enableStandardFullMode();
                });
            })
            .then(() => {
                return that._wait(100).then(() => {
                    return joyCon.enableIMUMode();
                });
            })
            .then(() => {
                return Promise.resolve(joyCon);
            })
            .catch(() => {
                return Promise.reject("connect device faild");
            });
    }

    catchJoyConEvent(values, packet) {
        if (!packet || !packet.actualOrientation) {
            return;
        }
        const {
            actualAccelerometer: accelerometer,
            buttonStatus: buttons,
            actualGyroscope: gyroscope,
            actualOrientation: orientation,
        } = packet;

        // orientation
        values.alpha = orientation.alpha;
        values.beta = orientation.beta;
        values.gamma = orientation.gamma;

        // analog stick

        const joystick = values.isLeft
            ? packet.analogStickLeft
            : packet.analogStickRight;
        values.horizontal = joystick.horizontal;
        values.vertical = joystick.vertical;

        // IMU
        const meterMultiplier = 300;
        values.accX = accelerometer.x * meterMultiplier;
        values.accY = accelerometer.y * meterMultiplier;
        values.accZ = accelerometer.z * meterMultiplier;

        const gyroscopeMultiplier = 300;
        values.gyrX = gyroscope.rps.x * gyroscopeMultiplier;
        values.gyrY = gyroscope.rps.y * gyroscopeMultiplier;
        values.gyrZ = gyroscope.rps.z * gyroscopeMultiplier;

        if (values.isLeft) {
            values.buttons.up = buttons.up;
            values.buttons.down = buttons.down;
            values.buttons.left = buttons.left;
            values.buttons.right = buttons.right;
            values.buttons.capture = buttons.capture;
            values.buttons.l = buttons.l || buttons.zl;
            values.buttons.minus = buttons.minus;
        } else {
            values.buttons.a = buttons.a;
            values.buttons.b = buttons.b;
            values.buttons.x = buttons.x;
            values.buttons.y = buttons.y;
            values.buttons.home = buttons.home;
            values.buttons.r = buttons.r || buttons.zr;
            values.buttons.plus = buttons.plus;
        }
    }

    /**
     * @returns {object} Metadata for this extension and its blocks.
     */
    getInfo() {
        return {
            id: "nsjoycon",
            name: Message.categoryName[this.setLocale()],
            menuIconURI: menuIconURI,
            blocks: [
                {
                    opcode: "connectRight",
                    text: Message.connectRight[this.setLocale()],
                    blockType: BlockType.REPORTER,
                },
                {
                    opcode: "connectLeft",
                    text: Message.connectLeft[this.setLocale()],
                    blockType: BlockType.REPORTER,
                },
                "---",
                {
                    opcode: "getJoyStick",
                    text: Message.getJoyStick[this.setLocale()],
                    blockType: BlockType.REPORTER,
                    arguments: {
                        LR: {
                            type: ArgumentType.STRING,
                            menu: "LeftRight",
                            defaultValue: "left",
                        },
                        HV: {
                            type: ArgumentType.STRING,
                            menu: "HorizontalVertical",
                            defaultValue: "horizontal",
                        },
                    },
                },
                {
                    opcode: "getAcceleration",
                    text: Message.getAcceleration[this.setLocale()],
                    blockType: BlockType.REPORTER,
                    arguments: {
                        LR: {
                            type: ArgumentType.STRING,
                            menu: "LeftRight",
                            defaultValue: "left",
                        },
                        XYZ: {
                            type: ArgumentType.STRING,
                            menu: "XYZ",
                            defaultValue: "x",
                        },
                    },
                },
                {
                    opcode: "getOrientation",
                    text: Message.getOrientation[this.setLocale()],
                    blockType: BlockType.REPORTER,
                    arguments: {
                        LR: {
                            type: ArgumentType.STRING,
                            menu: "LeftRight",
                            defaultValue: "left",
                        },
                        ORIENTATION: {
                            type: ArgumentType.STRING,
                            menu: "Orientation",
                            defaultValue: "alpha",
                        },
                    },
                },
                {
                    opcode: "getGyro",
                    text: Message.getGyro[this.setLocale()],
                    blockType: BlockType.REPORTER,
                    arguments: {
                        LR: {
                            type: ArgumentType.STRING,
                            menu: "LeftRight",
                            defaultValue: "left",
                        },
                        XYZ: {
                            type: ArgumentType.STRING,
                            menu: "XYZ",
                            defaultValue: "x",
                        },
                    },
                },
                "---",
                {
                    opcode: "whenButtonPressedRight",
                    text: Message.whenButtonPressedRight[this.setLocale()],
                    blockType: BlockType.HAT,
                    arguments: {
                        BUTTON: {
                            type: ArgumentType.STRING,
                            menu: "ButtonRight",
                            defaultValue: "x",
                        },
                        PRESSED: {
                            type: ArgumentType.BOOLEAN,
                            menu: "ButtonAction",
                            defaultValue: "true",
                        },
                    },
                },
                {
                    opcode: "whenButtonPressedLeft",
                    text: Message.whenButtonPressedLeft[this.setLocale()],
                    blockType: BlockType.HAT,
                    arguments: {
                        BUTTON: {
                            type: ArgumentType.STRING,
                            menu: "ButtonLeft",
                            defaultValue: "down",
                        },
                        PRESSED: {
                            type: ArgumentType.BOOLEAN,
                            menu: "ButtonAction",
                            defaultValue: "true",
                        },
                    },
                },
            ],
            menus: {
                LeftRight: {
                    items: this._getLeftRight,
                },
                HorizontalVertical: {
                    items: this._getHorizontalVertical,
                },
                XYZ: {
                    items: this._getXYZ,
                },
                Orientation: {
                    items: this._getOrientation,
                },
                ButtonRight: {
                    items: this._getButtonRight,
                },
                ButtonLeft: {
                    items: this._getButtonLeft,
                },
                ButtonAction: {
                    items: this._getButtonAction,
                },
            },
        };
    }

    get _getLeftRight() {
        return [
            {
                text: Message.menus.Left[this.setLocale()],
                value: "left",
            },
            {
                text: Message.menus.Right[this.setLocale()],
                value: "right",
            },
        ];
    }

    get _getHorizontalVertical() {
        return [
            {
                text: Message.menus.Horizontal[this.setLocale()],
                value: "horizontal",
            },
            {
                text: Message.menus.Vertical[this.setLocale()],
                value: "vertical",
            },
        ];
    }

    get _getXYZ() {
        return [
            {
                text: Message.menus.X[this.setLocale()],
                value: "x",
            },
            {
                text: Message.menus.Y[this.setLocale()],
                value: "y",
            },
            {
                text: Message.menus.Z[this.setLocale()],
                value: "z",
            },
        ];
    }

    get _getOrientation() {
        return [
            {
                text: Message.menus.Alpha[this.setLocale()],
                value: "alpha",
            },
            {
                text: Message.menus.Beta[this.setLocale()],
                value: "beta",
            },
            {
                text: Message.menus.Gamma[this.setLocale()],
                value: "gamma",
            },
        ];
    }

    get _getButtonLeft() {
        return [
            {
                text: Message.buttons.up[this.setLocale()],
                value: "up",
            },
            {
                text: Message.buttons.down[this.setLocale()],
                value: "down",
            },
            {
                text: Message.buttons.left[this.setLocale()],
                value: "left",
            },
            {
                text: Message.buttons.right[this.setLocale()],
                value: "right",
            },
            {
                text: Message.buttons.capture[this.setLocale()],
                value: "capture",
            },
            {
                text: Message.buttons.l[this.setLocale()],
                value: "l",
            },
            {
                text: Message.buttons.minus[this.setLocale()],
                value: "minus",
            },
        ];
    }

    get _getButtonRight() {
        return [
            {
                text: Message.buttons.a[this.setLocale()],
                value: "a",
            },
            {
                text: Message.buttons.b[this.setLocale()],
                value: "b",
            },
            {
                text: Message.buttons.x[this.setLocale()],
                value: "x",
            },
            {
                text: Message.buttons.y[this.setLocale()],
                value: "y",
            },
            {
                text: Message.buttons.home[this.setLocale()],
                value: "home",
            },
            {
                text: Message.buttons.r[this.setLocale()],
                value: "r",
            },
            {
                text: Message.buttons.plus[this.setLocale()],
                value: "plus",
            },
        ];
    }

    get _getButtonAction() {
        return [
            {
                text: Message.menus.Pressed[this.setLocale()],
                value: "true",
            },
            {
                text: Message.menus.Released[this.setLocale()],
                value: "false",
            },
        ];
    }

    connectRight() {
        if (this._connections.right.state === ConnectionState.NONE) {
            return Message.connectionState.none[this.setLocale()];
        }

        if (this._connections.right.state === ConnectionState.TRY) {
            return Message.connectionState.try[this.setLocale()];
        }

        if (this._connections.right.state === ConnectionState.CONNECTED) {
            return Message.connectionState.connected[this.setLocale()];
        }

        if (this._connections.right.state === ConnectionState.NOT_FOUND) {
            return Message.connectionState.not_found[this.setLocale()];
        }

        return "ERROR";
    }

    connectLeft() {
        if (this._connections.left.state === ConnectionState.NONE) {
            return Message.connectionState.none[this.setLocale()];
        }

        if (this._connections.left.state === ConnectionState.TRY) {
            return Message.connectionState.try[this.setLocale()];
        }

        if (this._connections.left.state === ConnectionState.CONNECTED) {
            return Message.connectionState.connected[this.setLocale()];
        }

        if (this._connections.left.state === ConnectionState.NOT_FOUND) {
            return Message.connectionState.not_found[this.setLocale()];
        }

        return "ERROR";
    }

    getJoyStick(args) {
        var lr = Cast.toString(args.LR);
        var dir = Cast.toString(args.HV);

        if (lr == "left") {
            if (dir == "horizontal") {
                return this._joyConLeftValues.horizontal === undefined
                    ? 0
                    : this._joyConLeftValues.horizontal;
            } else {
                return this._joyConLeftValues.vertical === undefined
                    ? 0
                    : this._joyConLeftValues.vertical;
            }
        } else {
            // right
            if (dir == "horizontal") {
                return this._joyConRightValues.horizontal === undefined
                    ? 0
                    : this._joyConRightValues.horizontal;
            } else {
                return this._joyConRightValues.vertical === undefined
                    ? 0
                    : this._joyConRightValues.vertical;
            }
        }
    }

    getAcceleration(args) {
        var lr = Cast.toString(args.LR);
        var xyz = Cast.toString(args.XYZ);

        if (lr == "left") {
            if (xyz == "x") {
                return this._joyConLeftValues.accX === undefined
                    ? 0
                    : this._joyConLeftValues.accX;
            } else if (xyz == "y") {
                return this._joyConLeftValues.accY === undefined
                    ? 0
                    : this._joyConLeftValues.accY;
            } else {
                return this._joyConLeftValues.accZ === undefined
                    ? 0
                    : this._joyConLeftValues.accZ;
            }
        } else {
            // right
            if (xyz == "x") {
                return this._joyConRightValues.accX === undefined
                    ? 0
                    : this._joyConRightValues.accX;
            } else if (xyz == "y") {
                return this._joyConRightValues.accY === undefined
                    ? 0
                    : this._joyConRightValues.accY;
            } else {
                return this._joyConRightValues.accZ === undefined
                    ? 0
                    : this._joyConRightValues.accZ;
            }
        }
    }

    getOrientation(args) {
        var lr = Cast.toString(args.LR);
        var orientation = Cast.toString(args.ORIENTATION);

        if (lr == "left") {
            if (orientation == "alpha") {
                return this._joyConLeftValues.alpha === undefined
                    ? 0
                    : this._joyConLeftValues.alpha;
            } else if (orientation == "beta") {
                return this._joyConLeftValues.beta === undefined
                    ? 0
                    : this._joyConLeftValues.beta;
            } else {
                return this._joyConLeftValues.gamma === undefined
                    ? 0
                    : this._joyConLeftValues.gamma;
            }
        } else {
            // right
            if (orientation == "alpha") {
                return this._joyConRightValues.accX === undefined
                    ? 0
                    : this._joyConRightValues.accX;
            } else if (orientation == "beta") {
                return this._joyConRightValues.beta === undefined
                    ? 0
                    : this._joyConRightValues.beta;
            } else {
                return this._joyConRightValues.gamma === undefined
                    ? 0
                    : this._joyConRightValues.gamma;
            }
        }
    }

    getGyro(args) {
        var lr = Cast.toString(args.LR);
        var xyz = Cast.toString(args.XYZ);

        if (lr == "left") {
            if (xyz == "x") {
                return this._joyConLeftValues.gyrX === undefined
                    ? 0
                    : this._joyConLeftValues.gyrX;
            } else if (xyz == "y") {
                return this._joyConLeftValues.gyrY === undefined
                    ? 0
                    : this._joyConLeftValues.gyrY;
            } else {
                return this._joyConLeftValues.gyrZ === undefined
                    ? 0
                    : this._joyConLeftValues.gyrZ;
            }
        } else {
            // right
            if (xyz == "x") {
                return this._joyConRightValues.gyrX === undefined
                    ? 0
                    : this._joyConRightValues.gyrX;
            } else if (xyz == "y") {
                return this._joyConRightValues.gyrY === undefined
                    ? 0
                    : this._joyConRightValues.gyrY;
            } else {
                return this._joyConRightValues.gyrZ === undefined
                    ? 0
                    : this._joyConRightValues.gyrZ;
            }
        }
    }

    whenButtonPressedLeft(args) {
        var button = Cast.toString(args.BUTTON);
        var pushed = Cast.toBoolean(args.PRESSED);

        switch (button) {
            case "up":
                return this._joyConLeftValues.buttons.up === pushed;
            case "down":
                return this._joyConLeftValues.buttons.down === pushed;
            case "left":
                return this._joyConLeftValues.buttons.left === pushed;
            case "right":
                return this._joyConLeftValues.buttons.right === pushed;
            case "capture":
                return this._joyConLeftValues.buttons.capture === pushed;
            case "l":
                return this._joyConLeftValues.buttons.l === pushed;
            case "minus":
                return this._joyConLeftValues.buttons.minus === pushed;
            default:
                return false;
        }
    }

    whenButtonPressedRight(args) {
        var button = Cast.toString(args.BUTTON);
        var pushed = Cast.toBoolean(args.PRESSED);

        switch (button) {
            case "a":
                return this._joyConRightValues.buttons.a === pushed;
            case "b":
                return this._joyConRightValues.buttons.b === pushed;
            case "x":
                return this._joyConRightValues.buttons.x === pushed;
            case "y":
                return this._joyConRightValues.buttons.y === pushed;
            case "home":
                return this._joyConRightValues.buttons.home === pushed;
            case "r":
                return this._joyConRightValues.buttons.r === pushed;
            case "plus":
                return this._joyConRightValues.buttons.plus === pushed;
            default:
                return false;
        }
    }

    setLocale() {
        let locale = formatMessage.setup().locale;
        if (AvailableLocales.includes(locale)) {
            return locale;
        } else {
            return "en";
        }
    }
}

module.exports = kurikitNSJoyConBlocks;
